/** Premium casino ambience */
import CasinoRoomBackground from 'components/desktop/CasinoRoomBackground';
import GoldDustOverlay from 'components/table/GoldDustOverlay';

export default function AmbientEffects() {
  const bokeh = [
    [10, 20], [25, 45], [75, 30], [88, 60], [18, 70], [82, 75], [48, 15],
  ];

  return (
    <div className="pointer-events-none absolute inset-0 z-0 overflow-hidden" aria-hidden>
      <CasinoRoomBackground />
      <GoldDustOverlay />
      <div className="tp-casino-spotlight absolute inset-0" />

      <div
        className="absolute left-1/2 top-[38%] -translate-x-1/2 -translate-y-1/2"
        style={{
          width: 'min(85vw, 1200px)',
          height: 'min(50vw, 480px)',
          borderRadius: '9999px',
          background: 'radial-gradient(ellipse at 50% 40%, rgba(255,235,180,0.08) 0%, rgba(11,110,79,0.12) 35%, transparent 70%)',
          filter: 'blur(40px)',
        }}
      />

      {bokeh.map(([left, top], i) => (
        <div
          key={i}
          className="tp-ambient-bokeh absolute rounded-full"
          style={{
            left: `${left}%`,
            top: `${top}%`,
            width: `${3 + (i % 2)}px`,
            height: `${3 + (i % 2)}px`,
            animationDelay: `${i * 1.1}s`,
            opacity: 0.3 + (i % 3) * 0.1,
          }}
        />
      ))}

      <div className="tp-ambient-vignette absolute inset-0" />
    </div>
  );
}
